import React from 'react';
import Grid from 'components/Custom/Grid';
import { getChecklists } from 'utils/ChecklistUtils';
import Checklist from 'classes/Checklist';
import { useAppContext } from 'hooks/useAppContext';

export default function ChecklistGrid() {
  const columns = Checklist.columns;
  const { selectedProject } = useAppContext();

  return (
    <Grid
      columns={columns}
      title="Checklists"
      getRecords={getChecklists}
      selectedProject={selectedProject}
      component="Inspections"
      enable={{ update: false, delete: false }}
      inspectionColumnTitle="Inspection #"
      options={{
        pageSizeOptions: [10, 15, 25],
        pageSize: 10
      }}
    />
  );
}
